<!--<nbc-breadcrumb></nbc-breadcrumb>-->
<nav class="breadcrumb" style="font-size:12px!important;">
  <ul>
    <li><a class="btn-link" routerLink="../../" title="Home">Home</a></li>
  </ul>
</nav>
<div class="container">
  <div class="content top-margin">
    <div class="container">
      <div class="row">
        <!-- Left side menu -->
        <!-- end left side menu -->
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <alert *ngIf="showAlertMessage" type="{{alert.type}}" close="closeAlert()">{{alert.msg}}</alert>
          <!-- Form Panel -->
          <div class="card contact-help">
            <form #formContactus="ngForm">
              <div class="panel-heading">
                <h3 class="card-title fw-bold">Contact Form</h3>
              </div>
              <div class="panel-body">
                <div class="form-horizontal">
                  <div class="row form-group">
                    <div class="col-md-3 text-end">
                      <label class="control-label">Full Name</label>
                    </div>
                    <div class="col-md-8">
                      <span [ngClass]="{'has-error':fullname.invalid && formContactus.submitted}">
                        <input type="text" class="form-control has-border" maxlength="120" placeholder="Full Name"
                          [(ngModel)]="model.fullName" name="fullname" #fullname="ngModel" id="fullname" required>
                      </span>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-3 text-end">
                      <label class="control-label">Contact Number</label>
                    </div>
                    <div class="col-md-4">
                      <span [ngClass]="{'has-error':contactNo.invalid && formContactus.submitted}">
                        <input type="text" class="form-control has-border" placeholder="Contact Number"
                          name="contactNo" #contactNo="ngModel" id="contactNo" [(ngModel)]="model.contactNo"
                          maxlength="30" required appInputRestriction="phonenumberformat">
                      </span>
                    </div>
                    <div class="col-md-4">
                      <input type="text" class="form-control has-border md" placeholder="Contact Number Extension"
                        name="contactext" #contactext="ngModel" id="contactext" [(ngModel)]="model.contactExt"
                        maxlength="10" appInputRestriction="phonenumberformat">
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-3 text-end">
                      <label class="control-label">Email address</label>
                    </div>
                    <div class="col-md-8">
                      <span [ngClass]="{'has-error':email.invalid && formContactus.submitted}">
                        <input type="email" class="form-control has-border" placeholder="Email" name="email"
                          #email="ngModel" id="email" [(ngModel)]="model.email" maxlength="75" required>
                      </span>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-3 text-end">
                      <label class="control-label">SSO</label>
                    </div>
                    <div class="col-md-8">
                      <input type="text" class="form-control has-border" name="ssoid" [(ngModel)]="model.ssoid"
                        maxlength="9" numbersOnly>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-3 text-end">
                      <label class="control-label">Subject</label>
                    </div>
                    <div class="col-md-8">
                      <span [ngClass]="{'has-error':subject.invalid && formContactus.submitted}">
                        <input type="text" class="form-control has-border" placeholder="Subject" maxlength="150"
                          [(ngModel)]="model.subject" name="subject" #subject="ngModel" id="subject" required>
                      </span>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-3 text-end">
                      <label class="control-label">Message</label>
                    </div>
                    <div class="col-md-8">
                      <span [ngClass]="{'has-error':message.invalid && formContactus.submitted}">
                        <textarea class="form-control has-border scroll-textarea" name="message" #message="ngModel"
                          id="message" maxlength="500" appInputRestriction="restrictChars" [(ngModel)]="model.message"
                          placeholder="Your message" required></textarea>
                      </span>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-3 text-end">
                      <label class="control-label">Attachment </label>
                    </div>
                    <div class="col-md-4">
                      <label for="file-upload" class="fileUpload btn btn-secondary btn-block">Attach screenshots or
                        documents</label>
                      <input id="file-upload" type="file" style="display: none;" (change)="uploaded($event)" />
                    </div>
                    <div class="col-md-5"></div>
                  </div>
                  <div class="row form-group" *ngIf="fileNames != null && fileNames.length > 0">
                    <div class="col-md-3"></div>
                    <div class="col-md-9">
                      <!--{{uploadText}}-->
                      <div class="file-names p-2" *ngFor="let uploaded_file of fileNames; index as i">
                        <i class="fa fa-trash text-danger" style="position:absolute; cursor: pointer;font-size: 15px;" title="Delete"
                          (click)="deleteFileUpload(uploaded_file.file, i, model.filePath)"></i>
                        <span class="form-box-filenames m-4">{{uploaded_file.file }}</span>
                      </div>
                    </div>
                    <br />
                    <br />
                  </div>
                  <!-- Form Actions -->
                  <div class="row form-actions">
                    <div class="col-md-4 offset-md-3">
                      <button type="submit" class="btn btn-default" (click)="submitContactUsDetails(formContactus)">
                        Submit </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>